import {ApiAdBanner, ApiLivestreamData} from "#/src/definitions/ApiDefinitions";
import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext, DataWrapped} from "#/src/definitions/AppDefinitions";
import {useData} from "vike-react/useData";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import {AdWrapper} from "#/src/components/AdWrapper";
import AppConstants from "#/src/utils/app-constants";
import {Adsense} from "@ctrl/react-adsense";

export function AdSection() {
  const {user} = usePageContext() as AppPageContext;
  const {data: livestreamData} = useData() as DataWrapped<ApiLivestreamData>;
  const mode = user.lightMode ? "LIGHT" : "DARK";
  const ad = livestreamData.adData.find((adData: ApiAdBanner) => adData.placement == "LIVE_AND_STREAMS" && adData.theme == mode);

  function render() {
    return <section className={"live-ad-section text-center mt-4"}>
      <div className={"d-inline-block"}>{renderAd()}</div>
    </section>
  }
  function renderAd() {
    if(!ad) {
      return <Adsense client={AppConstants.ADSENSE_CLIENT_ID} slot={"8213168607"} className={"campaign-banner type-750x200-adsense"} format={null} data-banner-id={`adsense-stream`}/>
    }
    return <AdWrapper ad={ad}>
      <div className={"campaign-banner type-750x200"}>
        <img alt={ad.alt} src={Attachments.getUrl(AttachmentNamespace.AD, ad)}/>
      </div>
    </AdWrapper>
  }
  return render();
}